import { fetchWithAuth } from './fetchWithAuth'

export async function updateTenant(
  token: string,
  id: string,
  body: Record<string, unknown>,
): Promise<void> {
  await fetchWithAuth(`/v1/tenants/${id}`, token, {
    method: 'PUT',
    body: JSON.stringify(body),
  })
}
